import { createReducer } from 'typesafe-actions';
import { get } from '../../../../common/utils/objectUtils';
import { BoughtProductActionType, LastBoughtProductAction } from './actions';
import { UserProductState } from './types';

const defaultState: UserProductState = {
    didInvalidate: false,
    identifier: '',
    isFetching: false,
    boughtProduct: {
        imageUrl: 'https://static-stage-release-shop1.westwing.eu/p/esszimmerstuehle-marcus-4-stueck-8544-71311-829526',
        name: 'Fake title',
        productSku: '',
    },
};
const boughtProductReducer = createReducer<UserProductState, BoughtProductActionType>(defaultState)
    .handleAction(LastBoughtProductAction.request, (state, { payload }) => ({
        ...state,
        isFetching: true,
        identifier: payload.identifier,
    }))
    .handleAction(LastBoughtProductAction.success, (state, { payload }) => ({
        ...state,
        boughtProduct: {
            imageUrl: get(payload, 'data.data.image_url', ''),
            name: get(payload, 'data.data.name', ''),
            productSku: get(payload, 'data.data.sku', ''),
        },
        identifier: payload.identifier,
    }))
    .handleAction(LastBoughtProductAction.failure, (state, { payload }) => ({
        ...state,
        isFetching: false,
        didInvalidate: true,
        error: payload.error,
    }));

export default boughtProductReducer;
